<template>
  <Container>
    <div class="row">
      <div class="col-lg-4 col-sm-6 mb-4">
        <div class="card shadow h-100">
          <div class="card-body">
            <h4 class="card-title">Statistics</h4>

            <DatePicker
              class="mb-2 w-100"
              v-model="start_date"
              placeholder="Start Date"
              format="DD-MM-YYYY"
              :disabled-date="disabledAfterEndDate"
              @input="onDateChange"
            ></DatePicker>

            <DatePicker
              class="mb-4 w-100"
              v-model="end_date"
              placeholder="End Date"
              format="DD-MM-YYYY"
              :disabled-date="disabledBeforeStartDate"
              @input="onDateChange"
            ></DatePicker>

            <div class="bg-soft-primary" style="border-radius: 12px">
              <div class="py-4 px-3">
                <h4>{{ bookings_count }} Bookings</h4>
                <router-link to="/">More Statistics</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-sm-6 mb-4">
        <div class="card shadow h-100">
          <div class="card-body">
            <h4 class="card-title">Occupancy</h4>
            <div class="px-3">
              <DonutChart v-if="loaded" :occupied="occupied" :height="300" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-sm-6 mb-4">
        <div class="card shadow h-100">
          <div class="card-body">
            <h4 class="card-title">Portal Distribution</h4>
            <div class="px-3">
              <PieChart v-if="loaded" :height="300" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <FullCalendar :options="calendarOptions" />
            <Booking :arrival="checkin_date" :departure="checkout_date" @submit="setBookings" />
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "./layouts/main";
import { mapActions } from "vuex";
import { confirmEmployee, getStatistics } from "@/store/api";
import DonutChart from "../components/donutChart";
import PieChart from "../components/pieChart";
import moment from "moment";
import bookingMixin from "../mixins/booking-mixin";

export default {
  components: {
    Container,
    DonutChart,
    PieChart,
  },

  mixins: [bookingMixin],

  data() {
    return {
      occupied: 0,
      loaded: false,
      bookings_count: "",
      start_date: moment().startOf("month")._d,
      end_date: moment().endOf("month")._d,
    };
  },

  methods: {
    ...mapActions(["login"]),

    disabledBeforeStartDate(date) {
      return date <= this.start_date;
    },

    disabledAfterEndDate(date) {
      if (!this.end_date) return false;
      return date >= this.end_date;
    },

    onDateChange() {
      if (this.start_date && this.end_date) {
        this.loadDashboard();
      }
    },

    loadDashboard() {
      this.loaded = false;
      getStatistics({
        start_date: moment(this.start_date).format("YYYY-MM-DD"),
        end_date: moment(this.end_date).format("YYYY-MM-DD"),
      }).then((response) => {
        this.bookings_count = response.bookings;
        this.occupied = response.occupancy;
        this.loaded = true;
      });
    },
  },

  created() {
    if (this.$route.query.confirmation_token) {
      confirmEmployee(this.$route.query.confirmation_token).then((response) => this.login(response));
      this.$router.push("/");
    }
    this.loadDashboard();
  },
};
</script>

<style>
.fc-event-start {
  margin-left: 4.5vw !important;
}

.fc-event-end {
  margin-right: 4.5vw !important;
}

.fc-highlight {
  background: rgba(85, 110, 230, 0.25) !important;
}

.fc-event {
  cursor: pointer !important;
}
</style>
